import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppState } from 'src/app/App.state';
import { QueryOptions } from 'src/app/global/domain/query.options';
import { ConciliacaoFormComponent } from 'src/app/global/forms/conciliacao-form/conciliacao-form.component';
import { VincularConciliacaoTedComponent } from 'src/app/global/forms/vincular-conciliacao-ted/vincular-conciliacao-ted.component';
import {
  ConciliacaoBancariaTedEvent,
  VisualizarConciliacaoBancariaTedcFilterOptions,
} from 'src/app/global/lists/visualizar-conciliacao-ted-list/visualizar-conciliacao-ted-list.component';
import { DialogService } from 'src/app/global/services/dialog.service';
import { ConciliacaoBancariaTed } from '../../domain/conciliacao-bancaria-ted.model';
import { ConciliacaoDTO } from '../../domain/dto/conciliacao.dto';
import { Page } from '../../domain/return-api.model';
import { ConciliacaoBancariaTedService } from '../../services/conciliacao-bancaria-ted.service';
import { ParcelaService } from '../../services/parcela.service';

@Component({
  selector: 'app-conciliacao-ted',
  templateUrl: './conciliacao-ted.component.html',
  styleUrls: ['./conciliacao-ted.component.css'],
})
export class ConciliacaoTedComponent implements OnInit {
  private static DELETE_ACTION = 'Deletar';
  private static EDITAR_ACTION = 'Editar';
  private static VINCULAR_ACTION = 'Vincular Parcela';

  queryOptions = new QueryOptions({ pageSize: 25 });

  page: Page<ConciliacaoBancariaTed> = new Page();
  totalRecords: number = 0;
  valorTotal: number = 0;

  loading: boolean = false;

  constructor(
    private service: ConciliacaoBancariaTedService,
    public appState: AppState,
    private dialog: MatDialog,
    private dialogService: DialogService,
    private parcelaService: ParcelaService,
  ) {
    const date = new Date();
    date.setHours(0, 0, 0);
    this.queryOptions.params = {
      dataInicio: date.getTime(),
      dataFim: new Date().getTime(),
    };
  }

  ngOnInit(): void {}

  list(pageNumber: number = 0): void {
    this.loading = true;
    this.appState.isLoading = true;
    this.queryOptions.pageNumber = pageNumber;

    const dataInicio: Date = new Date(this.queryOptions.params.dataInicio as number);
    dataInicio.setHours(0, 0, 0);
    const dataFim = new Date(this.queryOptions.params.dataFim as number);
    dataFim.setHours(23, 59, 59);

    const estadoId = this.queryOptions.params.estadoId as number;
    const postoUID = this.queryOptions.params.postoUID as string;
    const processado = this.queryOptions.params.processado as boolean;
    const rotaId = this.queryOptions.params.rotaId as number;

    this.queryOptions.params = {
      dataInicio: dataInicio.getTime(),
      dataFim: dataFim.getTime(),
      estadoId,
      postoUID,
      processado,
      rotaId,
    };

    this.service.findAllPageable(this.queryOptions).subscribe((response: Page<ConciliacaoBancariaTed>) => {
      this.loading = false;
      this.appState.isLoading = false;

      this.totalRecords = response.totalElements;
      console.log(this.queryOptions);
      this.service.getValorTotal(this.queryOptions).subscribe((resp: number) => {
        this.valorTotal = resp;
      });

      response.content = this.mapearAcoes(response.content);
      this.page = response;
    });
  }

  mapearAcoes(arquivos: ConciliacaoBancariaTed[]): ConciliacaoBancariaTed[] {
    const mapearAcoes = (arquivo: ConciliacaoBancariaTed): ConciliacaoBancariaTed => {
      const acoes = [];
      acoes.push(ConciliacaoTedComponent.DELETE_ACTION);
      acoes.push(ConciliacaoTedComponent.EDITAR_ACTION);
      acoes.push(ConciliacaoTedComponent.VINCULAR_ACTION);
      return { ...arquivo, acoes };
    };

    return arquivos?.map(mapearAcoes) ?? [];
  }

  onFilter(options: VisualizarConciliacaoBancariaTedcFilterOptions): void {
    const date = new Date();
    date.setHours(0, 0, 0, 0);

    this.queryOptions.params = {
      dataInicio: options.dataInicial ? options.dataInicial.getTime() : date.getTime(),
      dataFim: options.dataFinal ? options.dataFinal.getTime() : date.getTime(),
      estadoId: options.estadoId,
      postoUID: options.postoUID,
      processado: options.processado,
      rotaId: options.rotaId,
    };

    this.list();
  }

  async onAcaoClick(event: ConciliacaoBancariaTedEvent) {
    const actions = new Map<string, (conciliacao: ConciliacaoBancariaTed) => void>()
      .set(ConciliacaoTedComponent.DELETE_ACTION, (conciliacao: ConciliacaoBancariaTed) => {
        this.dialogService.confirmDialog('Deseja realmente deletar esse registro?', () => this.onDelete(conciliacao));
      })
      .set(ConciliacaoTedComponent.EDITAR_ACTION, (conciliacao: ConciliacaoBancariaTed) => {
        this.onEdit(conciliacao);
      })
      .set(ConciliacaoTedComponent.VINCULAR_ACTION, (conciliacao: ConciliacaoBancariaTed) => {
        this.onVincular(conciliacao);
      });

    actions.get(event.acao)(event.conciliacao);
  }

  async realizarAssociacao(conciliacaoBancariaTed: ConciliacaoBancariaTedEvent): Promise<void> {}

  onMenuAcaoClick(event: string) {}

  onNovo(): void {
    this.dialog
      .open(ConciliacaoFormComponent, {
        data: {
          action: 'novo',
          type: 'ted',
          usuario: null,
        },
        width: '300px',
      })
      .afterClosed()
      .subscribe((result: ConciliacaoDTO) => {
        if (result) {
          let ted = new ConciliacaoBancariaTed();
          ted.data = result.data;
          ted.contaDestino = result.contaDestino;
          ted.contaOrigem = result.contaOrigem;
          ted.name = result.name;
          ted.tipoConciliacaoBancaria = result.tipoConciliacaoBancaria;
          ted.banco = result.banco;
          ted.valor = result.valor;
          ted.identificador = result.identificador;

          this.service.create(ted).subscribe(
            () => {
              this.appState.isLoading = false;
              this.dialogService.feedbackSuccess('Operação realizada com sucesso!');
              this.list();
            },
            // tslint:disable-next-line: typedef
            (error) => {
              this.appState.isLoading = false;
              console.error(error);
              this.dialogService.feedbackError('Ocorreu um erro ao criar registro!');
              this.list();
            },
          );
        }
      });
  }

  onEdit(conciliacao: ConciliacaoBancariaTed): void {
    this.dialog
      .open(ConciliacaoFormComponent, {
        data: {
          action: 'update',
          type: 'ted',
          conciliacao: ConciliacaoBancariaTed.toConciliacaoDTO(conciliacao),
        },
        width: '300px',
      })
      .afterClosed()
      .subscribe((result: ConciliacaoDTO) => {
        if (result) {
          console.log(result.identificador);

          let ted = ConciliacaoDTO.toConciliacaoTed(result);

          this.service.create(ted).subscribe(
            () => {
              this.appState.isLoading = false;
              this.dialogService.feedbackSuccess('Operação realizada com sucesso!');
              this.list();
            },
            // tslint:disable-next-line: typedef
            (error) => {
              this.appState.isLoading = false;
              console.error(error);
              this.dialogService.feedbackError('Ocorreu um erro ao atualizar registro!');
              this.list();
            },
          );
        }
      });
  }

  onDelete(conciliacao: ConciliacaoBancariaTed): void {
    this.service.delete(conciliacao).subscribe((response) => {
      this.dialogService.feedbackInfo('Registro apagado.'), this.list();
      (error: HttpErrorResponse) => {
        this.dialogService.feedbackError('Ocorreu um erro ao apagar o registro: ' + error.message);
      };
    });
  }

  onVincular(conciliacao: ConciliacaoBancariaTed): void {
    this.dialog
      .open(VincularConciliacaoTedComponent, {
        data: {
          conciliacao: ConciliacaoBancariaTed.toConciliacaoDTO(conciliacao),
        },
      })
      .afterClosed()
      .subscribe((result: any) => {
        if (result) {
          this.service.vincular(result).subscribe(
            () => {
              this.appState.isLoading = false;
              this.dialogService.feedbackSuccess('Operação realizada com sucesso!');
              this.list();
            },
            // tslint:disable-next-line: typedef
            (error) => {
              this.appState.isLoading = false;
              this.dialogService.feedbackError('Ocorreu um erro ao vincular registro!');
              this.list();
            },
          );
        }
      });
  }

  onLoadArquivosPage(pageNumber: number): void {
    this.list(pageNumber);
  }
}
